import $ from "jquery";
import Foundation from 'foundation-sites';
import Swiper from 'swiper';

$(document).foundation();

$(document).ready(function($) {

  // News Swipper
  var swiper = new Swiper('.swiper-container.news', {
    pagination: {
      el: $(this).find('.swiper-pagination.news'),
      dynamicBullets: false
    },
    navigation: {
      nextEl: '.swiper-button-next.news',
      prevEl: '.swiper-button-prev.news',
    },
    spaceBetween: 0,
    autoHeight: false,
    slidesPerView: 1,
    loop: false,
    breakpoints: {
      640: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 4
      },
    }
  })

  // Expertise Swipper
  var swiper = new Swiper('.swiper-container.expertise', {
    // pagination: {
    //   el: $(this).find('.swiper-pagination.expertise'),
    //   dynamicBullets: false
    // },
    navigation: {
      nextEl: '.swiper-button-next.expertise',
      prevEl: '.swiper-button-prev.expertise',
    },
    spaceBetween: 0,
    autoHeight: false,
    slidesPerView: 1,
    loop: false,
    breakpoints: {
      640: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 3
      },
    }
  })

  // Examples Swipper
  var swiper = new Swiper('.swiper-container.examples', {
    pagination: {
      el: $(this).find('.swiper-pagination.examples'),
      dynamicBullets: false
    },
    navigation: {
      nextEl: '.swiper-button-next.examples',
      prevEl: '.swiper-button-prev.examples',
    },
    spaceBetween: 0,
    autoHeight: false,
    slidesPerView: 1,
    loop: false,
    breakpoints: {
      640: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 4
      },
    }
  })

  // Testimonials Swipper
  var swiper = new Swiper('.swiper-container.testimonials', {
    pagination: {
      el: $(this).find('.swiper-pagination.testimonials'),
      dynamicBullets: false
    },
    navigation: {
      nextEl: '.swiper-button-next.testimonials',
      prevEl: '.swiper-button-prev.testimonials',
    },
    spaceBetween: 0,
    autoHeight: false,
    slidesPerView: 1,
    loop: false,
    breakpoints: {
      640: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 4
      },
    }
  })

  // Bio Swipper
  var swiper = new Swiper('.swiper-container.bio', {
    pagination: {
      el: $(this).find('.swiper-pagination.bio'),
      dynamicBullets: false
    },
    navigation: {
      nextEl: '.swiper-button-next.bio',
      prevEl: '.swiper-button-prev.bio',
    },
    spaceBetween: 0,
    autoHeight: false,
    slidesPerView: 1,
    loop: false,
  })

  $('.off-canvas a').on('click', function() {
    $('.off-canvas').foundation('close');
    $('#nav-icon3').toggleClass('open');
  });
  $('#nav-icon3').click(function(){
		$(this).toggleClass('open');
	});
  $('.close-button').click(function(){
		$('#nav-icon3').toggleClass('open');
	});

  $('.tabs-title.is-active a').click(function(){
		$('.tabs-panel.is-active').toggleClass('is-active');
	});

});
